import React, { useContext, useEffect, useState } from "react";
import PageHeader from "../util/PageHeader";
import {FEATURES, PAGE_HEADERS} from "../util/Constants";
import Navigation, { NavigationRoutes } from "../util/Navigation";
import {
    INDUCT_MANAGEMENT_DELIVERY_WINDOW_ROUTE,
    INDUCT_MANAGEMENT_FORCE_INDUCT_ROUTE,
    INDUCT_MANAGEMENT_INDUCT_CONFIGURATION_ROUTE,
    INDUCT_MANAGEMENT_MANAGE_CYCLE_ROUTE,
    INDUCT_MANAGEMENT_ROUTES
} from "../util/RouteConstants";
import Column from "@amzn/meridian/column";
import { CycleManagementContext } from "./context/CycleManagementContext";
import Loader from "../loader/Loader";
import { PermissionsContext } from "../permissions/PermissionsContext";
import { getFeaturesFromParent } from "../handler/ParentDataHandler";

const InductManagementDetail = ({ history, location }) => {
    const { cycleViewModel, cycleDispatch } = useContext(CycleManagementContext);
    const { isUserAuthorisedForForceInduct } = useContext(PermissionsContext);

    const [routesWhenPermissionsEnabled, setRoutesWhenPermissionsEnabled] = useState([]);
    const [isPermissionsFlagEnabled, setIsPermissionsFlagEnabled] = useState(false);
    const [isInductConfigEnabled, setIsInductConfigEnabled] = useState(false);

    useEffect(() => {
        cycleDispatch({
            type: 'LOAD_VIEW',
            data: { dispatcher: cycleDispatch }
        });
    }, []);

    useEffect(() => {
        const getFeatureFlags = async () => {
            const featureStatus = await getFeaturesFromParent([
                FEATURES.IS_INDUCT_MANAGEMENT_TAB_PERMISSIONS_ENABLED,
                FEATURES.IS_INDUCT_CONFIGURATION_ENABLED
            ]);

            if (featureStatus.data) {
                if (featureStatus.data.isInductConfigurationEnabled) {
                    setIsInductConfigEnabled(true);
                }

                if (featureStatus.data.isInductManagementTabPermissionsEnabled) {
                    setIsPermissionsFlagEnabled(true);

                    const routesWithPermissions = [
                        INDUCT_MANAGEMENT_MANAGE_CYCLE_ROUTE,
                        ...(isUserAuthorisedForForceInduct ? [INDUCT_MANAGEMENT_FORCE_INDUCT_ROUTE] : []),
                        INDUCT_MANAGEMENT_DELIVERY_WINDOW_ROUTE,
                        ...(featureStatus.data.isInductConfigurationEnabled ? [INDUCT_MANAGEMENT_INDUCT_CONFIGURATION_ROUTE] : [])
                    ];
                    setRoutesWhenPermissionsEnabled(routesWithPermissions);
                }
            }
        };

        getFeatureFlags();
    }, [isUserAuthorisedForForceInduct]);

    if (cycleViewModel.loadingCycle || cycleViewModel.loadingNode) {
        return <Loader />;
    }

    const getDefaultRoutes = () => {
        if (isInductConfigEnabled) {
            return [...INDUCT_MANAGEMENT_ROUTES];
        }
        return INDUCT_MANAGEMENT_ROUTES.filter(
            route => route.path !== INDUCT_MANAGEMENT_INDUCT_CONFIGURATION_ROUTE.path
        );
    };

    return (
        <Column>
            <PageHeader {...PAGE_HEADERS.INDUCT_MANAGEMENT} />
            <Navigation
                routes={isPermissionsFlagEnabled ? routesWhenPermissionsEnabled : getDefaultRoutes()}
                location={location}
                history={history}
            />
            <NavigationRoutes
                routes={isPermissionsFlagEnabled ? routesWhenPermissionsEnabled : getDefaultRoutes()}
            />
        </Column>
    );
};

export default InductManagementDetail;



// WEBPACK FOOTER //
// ./src/components/inductmanagementv2/InductManagementDetail.js